import React from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'react-bootstrap'
import { FaInstagram, FaFacebook, FaWhatsapp, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa'

const NAV_LINKS = [
  { to: '/',                label: 'Home' },
  { to: '/quem-somos',      label: 'Quem Somos' },
  { to: '/nossos-produtos', label: 'Nossos Produtos' },
  { to: '/pontos-de-venda', label: 'Pontos de Venda' },
  { to: '/seja-revendedor', label: 'Seja um Revendedor' },
]

export default function Footer() {
  return (
    <footer className="cf-footer">
      <Container>
        <Row className="gy-5">
          {/* Brand */}
          <Col lg={4} md={6}>
            <img
              src="/images/logo_cleanfoods_quadrado.png"
              alt="Clean Foods Brasil"
              className="footer-logo mb-4"
            />
            <p style={{ fontSize: '0.9rem', lineHeight: 1.7 }}>
              Desde 2015, transformando a alimentação saudável em algo prático, saboroso e acessível.
              Pioneira no interior de São Paulo.
            </p>
            <div className="mt-3">
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="social-icon" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className="social-icon" aria-label="Facebook">
                <FaFacebook />
              </a>
              <a href="https://wa.me/5514991718448" target="_blank" rel="noreferrer" className="social-icon" aria-label="WhatsApp">
                <FaWhatsapp />
              </a>
            </div>
          </Col>

          {/* Links */}
          <Col lg={2} md={3} sm={6}>
            <p className="footer-heading">Menu</p>
            {NAV_LINKS.map((link) => (
              <Link key={link.to} to={link.to} className="footer-link">
                {link.label}
              </Link>
            ))}
          </Col>

          {/* Contato */}
          <Col lg={3} md={3} sm={6}>
            <p className="footer-heading">Contato</p>
            <p className="footer-link d-flex align-items-center gap-2">
              <FaMapMarkerAlt className="text-cf-yellow flex-shrink-0" />
              Bauru, São Paulo – Brasil
            </p>
            <a href="tel:+5514991718448" className="footer-link d-flex align-items-center gap-2">
              <FaPhone className="text-cf-yellow flex-shrink-0" />
              (14) 99171-8448
            </a>
            <a href="mailto:Cleanfoods@hotmail.com" className="footer-link d-flex align-items-center gap-2">
              <FaEnvelope className="text-cf-yellow flex-shrink-0" />
              Cleanfoods@hotmail.com
            </a>
          </Col>

          {/* Diferenciais */}
          <Col lg={3}>
            <p className="footer-heading">Diferenciais</p>
            {[
              'Sem glúten e sem lactose',
              'Sem conservantes e sem óleos',
              'Pronto em apenas 6 minutos',
              'Validade de até 180 dias',
              'Curadoria técnica rigorosa',
              'Frota própria refrigerada',
            ].map((item) => (
              <p key={item} className="mb-1" style={{ fontSize: '0.88rem', color: 'var(--cf-muted)' }}>
                <span className="text-cf-yellow me-2">✓</span>
                {item}
              </p>
            ))}
          </Col>
        </Row>

        {/* <div className="footer-bottom d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
          <p className="mb-0">
            © {new Date().getFullYear()} Clean Foods Brasil. Todos os direitos reservados.
          </p>
          <p className="mb-0">
            Feito com <span className="text-cf-yellow">♥</span> para quem vive com performance
          </p>
        </div> */}
      </Container>
    </footer>
  )
}
